import {
  GET_ALL_SANCTIONS,
  GET_ALL_SANCTIONS_ERROR,
  GET_ALL_SANCTIONS_SUCCESS,
  GET_CONTRACTUAL_BEHAVIOR_SUMMARY,
  GET_CONTRACTUAL_BEHAVIOR_SUMMARY_BY_REVIEWS,
  GET_CONTRACTUAL_BEHAVIOR_SUMMARY_BY_REVIEWS_ERROR,
  GET_CONTRACTUAL_BEHAVIOR_SUMMARY_BY_REVIEWS_SUCCESS,
  GET_CONTRACTUAL_BEHAVIOR_SUMMARY_ERROR,
  GET_CONTRACTUAL_BEHAVIOR_SUMMARY_SUCCESS,
  GET_SANCTIONS_BY_PROCESS_TYPE,
  GET_SANCTIONS_BY_PROCESS_TYPE_ERROR,
  GET_SANCTIONS_BY_PROCESS_TYPE_SUCCESS
} from './ContractualBehavior.actions'

const contractualBehaviorState = {
  agilePurchase: {
    rate: 0,
    sanctions: []
  },
  directDeals: {
    rate: 0,
    sanctions: []
  },
  dni: '',
  error: undefined,
  errorByReviews: undefined,
  frameworkAgreement: {
    rate: 0,
    sanctions: []
  },
  hasNoRate: false,
  loading: true,
  loadingByReviews: true,
  loadingAllSanctions: true,
  max: 5,
  months: 24,
  nonComplianceSanctions: 0,
  voidedSanctions: 0,
  percentage: '',
  purchaseOrders: 0,
  rate: 0,
  rateByReviews: 0,
  requestedByReviews: false,
  receivedContracts: 0,
  reviewedContracts: 0,
  reviewedPercentage: 0,
  tenders: {
    rate: 0,
    sanctions: []
  }
}

/**
 * The contractual behavior reducer.
 */
const contractualBehaviorReducer = (state = contractualBehaviorState, { payload, type }) => {
  switch (type) {
    case GET_SANCTIONS_BY_PROCESS_TYPE:
    case GET_CONTRACTUAL_BEHAVIOR_SUMMARY:
    case GET_ALL_SANCTIONS: {
      return { ...state, loading: true }
    }
    case GET_CONTRACTUAL_BEHAVIOR_SUMMARY_BY_REVIEWS: {
      return { ...state, loadingByReviews: true, requestedByReviews: true }
    }
    case GET_CONTRACTUAL_BEHAVIOR_SUMMARY_SUCCESS: {
      return {
        ...state,
        loading: false,
        dni: payload.dni,
        hasNoRate: payload.hasNoRate,
        rate: payload.rate,
        max: payload.max,
        percentage: payload.percentage,
        purchaseOrders: payload.purchaseOrders,
        nonComplianceSanctions: payload.nonComplianceSanctions,
        voidedSanctions: payload.voidedSanctions
      }
    }
    case GET_CONTRACTUAL_BEHAVIOR_SUMMARY_BY_REVIEWS_SUCCESS: {
      return {
        ...state,
        receivedContracts: payload.receivedContracts,
        loadingByReviews: false,
        rateByReviews: payload.rateByReviews,
        requestedByReviews: false,
        reviewedContracts: payload.reviewedContracts,
        reviewedPercentage: payload.reviewedPercentage
      }
    }
    case GET_ALL_SANCTIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        tenders: payload.tenders,
        frameworkAgreement: payload.frameworkAgreement,
        agilePurchase: payload.agilePurchase,
        directDeals: payload.directDeals,
        loadingAllSanctions: false
      }
    }
    case GET_SANCTIONS_BY_PROCESS_TYPE_SUCCESS: {
      return {
        ...state,
        loading: false,
        [payload.processTypeName]: {
          rate: payload.rate,
          sanctions: payload.sanctions
        }
      }
    }
    case GET_SANCTIONS_BY_PROCESS_TYPE_ERROR:
    case GET_CONTRACTUAL_BEHAVIOR_SUMMARY_ERROR:
    case GET_ALL_SANCTIONS_ERROR: {
      return {
        ...state,
        loading: false,
        error: payload.error,
        loadingAllSanctions: false
      }
    }
    case GET_CONTRACTUAL_BEHAVIOR_SUMMARY_BY_REVIEWS_ERROR: {
      return {
        ...state,
        loadingByReviews: false,
        errorByReviews: payload.error,
        requestedByReviews: false
      }
    }
    default: {
      return state
    }
  }
}

export default contractualBehaviorReducer
